import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Linkedin, Twitter, Facebook, Mail, MapPin, Phone } from 'lucide-react';

const Footer = () => {
  const [email, setEmail] = useState('');

  const handleNewsletterSubmit = (e) => {
    e.preventDefault();
    // Handle newsletter submission
    console.log('Newsletter signup:', email);
    setEmail('');
    alert('Thank you for subscribing!');
  };

  const footerLinks = {
    company: [
      { name: 'About Us', path: '/about' },
      { name: 'Careers', path: '/careers' },
      { name: 'Press', path: '/press' },
      { name: 'Contact', path: '/contact' },
    ],
    talents: [
      { name: 'Models', path: '/talents?category=models' },
      { name: 'Actors', path: '/talents?category=actors' },
      { name: 'Creators', path: '/talents?category=creators' },
      { name: 'Voice', path: '/talents?category=voice' },
    ],
    resources: [
      { name: 'Apply Now', path: '/apply' },
      { name: 'Book Talent', path: '/book' },
      { name: 'Castings', path: '/castings' },
      { name: 'News', path: '/news' },
    ],
  };

  const socialLinks = [
    { icon: Instagram, href: 'https://instagram.com', label: 'Instagram' },
    { icon: Linkedin, href: 'https://linkedin.com', label: 'LinkedIn' },
    { icon: Twitter, href: 'https://twitter.com', label: 'Twitter' },
    { icon: Facebook, href: 'https://facebook.com', label: 'Facebook' },
  ];

  return (
    <footer className="bg-[#1a1a1a] text-white">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12">
          {/* Brand & Newsletter */}
          <div className="lg:col-span-2">
            <Link to="/" className="inline-block mb-6">
              <img
                src="/images/hutson-logo-white.png"
                alt="Hutson Talent Agency"
                className="h-16 w-auto"
              />
            </Link>
            <p className="text-gray-400 mb-6 max-w-md">
              Discovering and nurturing exceptional talent for global campaigns and productions since 1995.
            </p>
            
            {/* Newsletter */}
            <div className="mb-6">
              <h4 className="text-sm font-semibold tracking-wider mb-4">NEWSLETTER</h4>
              <form onSubmit={handleNewsletterSubmit} className="flex">
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Enter your email"
                  className="flex-1 px-4 py-3 bg-gray-800 border border-gray-700 text-white placeholder-gray-500 focus:outline-none focus:border-[#c9a94d] transition-colors"
                  required
                />
                <button
                  type="submit"
                  className="px-6 py-3 bg-[#c9a94d] text-black font-medium hover:bg-[#b89a3d] transition-colors"
                >
                  SIGN UP
                </button>
              </form>
            </div>

            {/* Social Links */}
            <div className="flex space-x-4">
              {socialLinks.map((social) => (
                <a
                  key={social.label}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="p-2 bg-gray-800 text-gray-400 hover:bg-[#c9a94d] hover:text-black transition-all duration-300"
                  aria-label={social.label}
                >
                  <social.icon className="w-5 h-5" />
                </a>
              ))}
            </div>
          </div>

          {/* Company Links */}
          <div>
            <h4 className="text-sm font-semibold tracking-wider mb-6">COMPANY</h4>
            <ul className="space-y-3">
              {footerLinks.company.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.path}
                    className="text-gray-400 hover:text-[#c9a94d] transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Talents Links */}
          <div>
            <h4 className="text-sm font-semibold tracking-wider mb-6">TALENTS</h4>
            <ul className="space-y-3">
              {footerLinks.talents.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.path}
                    className="text-gray-400 hover:text-[#c9a94d] transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Resources Links */}
          <div>
            <h4 className="text-sm font-semibold tracking-wider mb-6">RESOURCES</h4>
            <ul className="space-y-3">
              {footerLinks.resources.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.path}
                    className="text-gray-400 hover:text-[#c9a94d] transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Contact Info */}
        <div className="mt-12 pt-8 border-t border-gray-800">
          <div className="flex flex-wrap gap-8 text-gray-400 text-sm">
            <div className="flex items-center space-x-2">
              <MapPin className="w-4 h-4 text-[#c9a94d]" />
              <span>35 Burtis Street, Portsmouth, VA 23702</span>
            </div>
            <div className="flex items-center space-x-2">
              <Mail className="w-4 h-4 text-[#c9a94d]" />
              <a href="mailto:sylvia@hutsontalentagency.com" className="hover:text-[#c9a94d] transition-colors">
                sylvia@hutsontalentagency.com
              </a>
            </div>
            <div className="flex items-center space-x-2">
              <Phone className="w-4 h-4 text-[#c9a94d]" />
              <a href="tel:+17576736436" className="hover:text-[#c9a94d] transition-colors">
                (757) 673-6436
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col sm:flex-row justify-between items-center text-sm text-gray-500">
            <p>© 2025 Hutson Talent Agency. All rights reserved.</p>
            <div className="flex space-x-6 mt-4 sm:mt-0">
              <Link to="/privacy" className="hover:text-[#c9a94d] transition-colors">
                Privacy Policy
              </Link>
              <Link to="/terms" className="hover:text-[#c9a94d] transition-colors">
                Terms of Service
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
